import { Result } from '@puzzlemania/shared';
import { economyStore } from './economy.store';
import { hasValidPrefix } from './valid-prefixes';
const MAX_COINS = 9999999;
const MAX_GEMS = 99999;
export class EconomyService {
    /**
     * Optional hook fired after economyStore is updated, once per successful credit/debit.
     * The composition root wires this to real server-side validation (a Postgres RPC
     * call) for the Supabase-backed (non-DEV) path — DEV/Mock mode passes nothing, so
     * credit()/debit() behave exactly as before. economyStore stays the optimistic local
     * cache; this hook is what makes the server the actual source of truth underneath.
     */
    constructor(_onTransaction) {
        this._onTransaction = _onTransaction;
    }
    getBalance(type) {
        const s = economyStore.getState();
        return type === 'coins' ? s.coins : s.gems;
    }
    credit(type, amount, sourceId) {
        if (!hasValidPrefix(sourceId)) {
            throw new Error(`Invalid sourceId prefix: "${sourceId}"`);
        }
        economyStore.setState((s) => {
            if (type === 'coins')
                return { coins: Math.min(s.coins + amount, MAX_COINS) };
            return { gems: Math.min(s.gems + amount, MAX_GEMS) };
        });
        this._onTransaction?.({
            kind: 'credit',
            currencyType: type,
            amount,
            id: sourceId,
            nonce: crypto.randomUUID(),
        });
    }
    debit(type, amount, reasonId) {
        if (!hasValidPrefix(reasonId)) {
            throw new Error(`Invalid reasonId prefix: "${reasonId}"`);
        }
        const s = economyStore.getState();
        const balance = type === 'coins' ? s.coins : s.gems;
        if (balance < amount) {
            return Result.err('insufficient_balance');
        }
        economyStore.setState((cur) => {
            if (type === 'coins')
                return { coins: cur.coins - amount };
            return { gems: cur.gems - amount };
        });
        this._onTransaction?.({
            kind: 'debit',
            currencyType: type,
            amount,
            id: reasonId,
            nonce: crypto.randomUUID(),
        });
        return Result.ok(undefined);
    }
}
